import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

import DateRangePicker from "@/components/Base/DateRangePicker.vue";
import useScreenSize from "@/composables/useScreenSize";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import Immobilie from "@/models/immobilie.model";
import { ImmobilieStatus, translatedPropertyStatus } from "@/models/immobilie/interfaces/IImmobilie";
import User from "@/models/user";
import { DateFieldTypes, DateFilters } from "@/store/store.types";
import { IonButton, IonIcon, IonItem } from '@ionic/vue';
import { refreshOutline } from "ionicons/icons";
import { computed, ComputedRef, reactive, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from "vue-router";
import PersonFilter from "./PersonFilter.vue";
import StatusFilter from './StatusFilter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyMapFilter',
  setup(__props) {

const { t } = useI18n({ useScope: "global" });

const store = useStore();
const router = useRouter();
const organisationPrefix: ComputedRef<string> = computed(() => {
  const currentUser: User | null = User.query().first();
  return currentUser ? currentUser.organisationPrefix : "";
});
const { user } = useUser();
const featureFlags = computed(() => user.value?.organisation?.featureFlags);

const organizationUsers = computed(() => {
  return store.state.user.organizationUsers;
});

const isMobile = computed(() => {
  return store.getters["app/isMobile"];
});

const { isMaxSmall } = useScreenSize();

const immobilieStatuses = [
  {
    label: translatedPropertyStatus(ImmobilieStatus.ABGESCHLOSSEN, t),
    value: ImmobilieStatus.ABGESCHLOSSEN,
  },
  {
    label: translatedPropertyStatus(ImmobilieStatus.ANGELEGT, t),
    value: ImmobilieStatus.ANGELEGT,
  },
  {
    label: translatedPropertyStatus(ImmobilieStatus.ARCHIVIERT, t),
    value: ImmobilieStatus.ARCHIVIERT,
  },
  {
    label: translatedPropertyStatus(ImmobilieStatus.FREIGEGEBEN, t),
    value: ImmobilieStatus.FREIGEGEBEN,
  },
  {
    label: translatedPropertyStatus(ImmobilieStatus.GEPLANT, t),
    value: ImmobilieStatus.GEPLANT,
  },
  {
    label: translatedPropertyStatus(ImmobilieStatus.IN_DURCHFUEHRUNG, t),
    value: ImmobilieStatus.IN_DURCHFUEHRUNG,
  },
  {
    label: translatedPropertyStatus("", t),
    value: null,
  },
];

const surveyDateFilterOptions = ref<{ label: string, value: DateFieldTypes; }[]>([
  { label: t(`${organisationPrefix.value}hzba.datum.begehung`), value: "begehungsdatum" },
  { label: t(`${organisationPrefix.value}hzba.datum.sichtung`), value: "sichtungsdatum" }
]);

const personFilter = ref([]);
const statusFilter = ref([]);
const surveyDateFilter = ref<DateFilters>([]);
const dateStartValues = reactive<Record<string, string>>({});
const dateEndValues = reactive<Record<string, string>>({});

function clearFilters() {
  statusFilter.value = [];
  personFilter.value = [];
  surveyDateFilter.value = [];
  Object.keys(dateStartValues).forEach((key) => {
    dateStartValues[key] = "";
    dateEndValues[key] = "";
  });
}

watch(personFilter, (newVal) => {
  Immobilie.dispatch("setPersonFilter", newVal);
});

watch(statusFilter, (newVal) => {
  Immobilie.dispatch("setStatusFilter", newVal);
});

watch(surveyDateFilter, (newVal) => {
  Immobilie.dispatch("setSurveyDatumFilter", newVal);
});

const routeName = computed(() => { return router.currentRoute.value.name; });

watch(routeName, (newVal: any, oldVal: any) => {
  if (oldVal === "propertiesMap") {
    clearFilters();
  }
});

const updateSurveyDateFilter = (option: DateFieldTypes, value: any) => {
  if (Array.isArray(value)) {
    dateStartValues[option] = value[0];
    dateEndValues[option] = value[1];
  } else {
    dateStartValues[option] = value;
    dateEndValues[option] = "";
  }
  const existingFilters = surveyDateFilter.value.filter(el => el.option !== option);
  if (value !== "") {
    existingFilters.push({ option, value });
  }
  surveyDateFilter.value = existingFilters;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["absolute top-0 pt-2 z-10 bg-transparent", isMobile.value ? 'map-filter-width-mobile' : 'map-filter-width'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex gap-2 overflow-x-auto rounded-lg", [{ 'hide-scrollbar': isMobile.value }, _unref(isMaxSmall) ? 'justify-start' : 'justify-center']])
    }, [
      (featureFlags.value?.statusFilter)
        ? (_openBlock(), _createBlock(StatusFilter, {
            key: 0,
            ref: "firstItemRef",
            statusFilter: statusFilter.value,
            "onUpdate:statusFilter": _cache[0] || (_cache[0] = ($event: any) => ((statusFilter).value = $event)),
            class: "min-width-filter-buttons",
            "selected-statuses": statusFilter.value,
            options: immobilieStatuses,
            "ui-mode": "map"
          }, null, 8, ["statusFilter", "selected-statuses"]))
        : _createCommentVNode("", true),
      (featureFlags.value?.personFilter)
        ? (_openBlock(), _createBlock(PersonFilter, {
            key: 1,
            personFilter: personFilter.value,
            "onUpdate:personFilter": _cache[1] || (_cache[1] = ($event: any) => ((personFilter).value = $event)),
            class: "min-width-filter-buttons",
            "selected-persons": personFilter.value,
            options: organizationUsers.value,
            "ui-mode": "map"
          }, null, 8, ["personFilter", "selected-persons", "options"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveyDateFilterOptions.value, (option) => {
        return (_openBlock(), _createBlock(_unref(IonItem), {
          key: option.value,
          class: "mapFilterButton min-width-filter-buttons",
          lines: "none"
        }, {
          default: _withCtx(() => [
            _createVNode(DateRangePicker, {
              class: _normalizeClass(["rounded-lg whitespace-nowrap mx-0.5 flex items-center", { 'placeholder-style': !dateStartValues[option.value] }]),
              start: dateStartValues[option.value],
              end: dateEndValues[option.value],
              placeholder: option.label,
              "show-icon": true,
              "offset-y": 8,
              "show-backdrop": false,
              "onUpdate:range": ($event: any) => (updateSurveyDateFilter(option.value, $event)),
              "onUpdate:single": ($event: any) => (updateSurveyDateFilter(option.value, $event))
            }, null, 8, ["class", "start", "end", "placeholder", "onUpdate:range", "onUpdate:single"])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (statusFilter.value.length > 0 || personFilter.value.length > 0 || surveyDateFilter.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 2,
            color: "light",
            class: "m-0 resetButton",
            onClick: clearFilters
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                icon: _unref(refreshOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})